import styled, { keyframes } from 'styled-components';
import { Button, Modal } from 'antd';
import * as palette from '../../styles/variables';


const slideInDown = keyframes`
0% { clip-path: inset(0 0% 60% 0); }
50% { clip-path: inset(0 0% 0% 0); }
100% { clip-path: inset(0); }
`;

const fadeText = keyframes` 
   from {
     opacity: 0;
     transform: translate3d(0, 100%, 0);
   }
   to {
     opacity: 1;
     transform: none;
   }
 `;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: ${props => !props.PermissionModal && !props.TextToSpeech && 'absolute'};
  pointer-events: ${props => (props.visibility === 'true' ? 'all' : 'none')};

  .inputBox{
    height:45px;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: ${props => props.efaxModal ? 'column' : props.forceSave ? 'column' : 'row'};
  align-items: center;
  justify-content: center;
  padding: ${props => props.forceSave && '30px 50px'};
  height: ${props => props.forceSave && '225px'};
  justify-content: ${props => props.forceSave && 'space-evenly'};
  .anticon {
    color: ${props => props.forceSave && '#f9c000'};
    font-size: ${props => props.forceSave && '50px'};
  }
  p {
    color: ${props => props.forceSave && '#90580b'};
    line-height:  ${props => props.forceSave && '2'};
  }
  .ant-modal-body {
    padding: ${props => props.padding ? props.padding : props.forceSave && '0 !important'}; 
  }
  .warning-text {
    font-size: 18px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    > span {
      margin-right: 5px;
      &.text-highlighter {
        font-weight: bold;
      }
      > span.text-highlighter {
        font-weight: bold;
        margin-left: 5px;
        display: inline-block;
      }
    }
  }
  .inactivity {   
    height: 200px;
    padding: 0 40px;
    letter-spacing: 1px;
    font-weight: 600;
    justify-content: space-evenly;
    flex-direction: column;
    font-size: 15px;
    line-height: 2;
    color: #90580b;
    .anticon {
      font-size: 50px;
      color: #f9c000;
    }
  }
  .delete-warning-text {
    margin: 20px;
    margin-bottom: 0px;
    .deleteIcon {
      position: relative;
      text-align: center;
      margin-bottom: -25px;
      i.anticon.anticon-warning {
        position: absolute;
        bottom: 30%;
        font-size: 60px;
        right: 30%;
      }
    }
    span {
      font-size: 14px !important;
      font-weight: 600;
      letter-spacing: 0.5px;
      color: #000;
      font-family: Montserrat !important;
    }
  }
  .uploadResult {
    height: 350px;
    overflow: hidden;
    overflow-y: auto;
    ::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  }
`;

export const PreviewModalContainer = styled.div`
height: 80vh;
width:100%;
overflow: auto;
&::-webkit-scrollbar {
  display: none;
}
`;

export const AdduserSec = styled.div`
  &.adduserSec {
    height: ${props => (props.efax ? '350px' : '450px')};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: ${props => (props.isMaster ? 'flex-start' : 'center')};
    @media (max-width: 768px) {
      height: fit-content;
    }
  }
  .ant-steps {
    display: flex;
    width: ${props => (props.efax ? '650px' : '400px')};
    margin-top: ${props => !props.isStepTwo && !props.efax && '10px'};
    margin-bottom: ${props => !props.efax && '25px'};
    margin-top: ${props =>
    props.isStepTwo && props.efax
      ? '43px'
      : props.efax
        ? '50px'
        : props.isStepTwo || props.isMaster
          ? '-3px'
          : props.initialConfig && '-32px'};
    @media (max-width: 768px) {
      width: auto !important;
      margin-top: 0px;
    }
  }
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background-color: #000;
    height: 2px;
  }
  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background-color: #e8e8e8;
    height: 2px;
  }
  .ant-steps-item-title {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }
  .ant-steps-item-process .ant-steps-item-icon {
    background: #000;
    border-color: #000 !important;
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    background-color: #fff;
    border-color: #000;
  }
  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: #000;
  }
  .ant-steps-item-icon {
    line-height: 28px;
  }
  .userOption {
    display: flex;
    margin: ${props => (props.initialConfig ? '8px' : '25px')};
    justify-content: center;
    p {
      font-size: 12px;
      line-height: 1.5;
      font-weight: 800;
      cursor: pointer;
      text-transform: uppercase;
      margin: 10px;
      padding: 25px;
      padding-top: 10px;
      padding-bottom: 10px;
      border-radius: 25px;
      color: rgb(107, 141, 214);
      box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 1px 2px rgb(0 0 0 / 23%);
      border: 2px solid rgb(107, 141, 214);
    }
    .selected {
      border: 2px solid transparent;
      background: linear-gradient(to right, rgb(107, 141, 214), rgb(142, 55, 215));
      color: #fff !important;
    }
  }
  .ant-divider,
  .ant-divider-vertical {
    top: -29px;
    background: #fff !important;
    margin-bottom: 5px !important;
  }
  .ant-divider-inner-text {
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 700;
    color: #000;
  }
  .layout {
    display: flex;
    flex-direction: column;
    margin-top: 0;
    border-radius: 5px;
    padding: 5px;
    width: 500px;
    .ant-empty {
      margin: 55px !important;
    }
    .fetchingDetails {
      height: 240px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      text-transform: uppercase;
      font-weight: 700;
    }
  }
  .ant-divider-horizontal.ant-divider-with-text-left::before,
  .ant-divider-horizontal.ant-divider-with-text-left::after {
    border-top: 1px solid rgb(163 161 161) !important;
  }
`;

export const AttachmentCollapse = styled.div`
  .ant-collapse .ant-collapse-item .ant-collapse-header {
    text-transform: uppercase !important;
    font-size: 14px;
  }
`;

export const LoginContainer = styled.div`
  flex-direction: column;
  width: 70%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items:center;
  margin:auto;
  .ant-modal-header {
    display: none;
  }
  .ant-modal-body {
    padding: 34px;
  }

  .login-logo {
    animation: ${fadeText} 1s ease-in-out 0s forwards;
  }
  .content-body {
    animation: ${fadeText} 1s ease-in-out 0s forwards;
  }
  .forgot-btn {
    animation: ${fadeText} 1.2s ease-in-out 0s forwards;
  }
  .footer {
    animation: ${fadeText} 1.8s ease-in-out 0s forwards;     
  }
`;

export const ModalContainer = styled.div`
  width: 100%;
  max-width: ${props => (props.user ? '' : props.width || '350px')};
  width: ${props => props.auditModal && props.width};
  height: ${props => props.auditModal && '100%'};
  display: ${props => props.auditModal && 'flex'};
  align-items: ${props => props.auditModal && 'center'};
  justify-content: ${props => props.auditModal && 'center'};
  .inputBox > input {
    margin-bottom: 0px !important;
  }
  .ant-input {
    margin-bottom: ${props => !props.signUp && '12px'};
    color: #555555;
    font-size: 16px;
    font-weight: 600;
  }
  .ant-input-suffix {
    top: 21px !important;
  }
  .ant-input:placeholder-shown {
    font-size: 14px;
    font-weight: normal;
  }
  .ant-input:hover,
  .ant-input:focus {
    border-color: #b9b8b8 !important;
    border-right-width: 1px !important;
    box-shadow: none !important;
  }
  .user_input {
    height: ${props => !props.efax ? '300px' : '350px' };
    width: 450px;
    overflow: hidden;
    display: ${props => props.efax && 'flex'};
    align-items: ${props => props.efax && 'center'};
    justify-content: ${props => props.efax && 'center'};
    width: ${props => props.efax && '100%'};
  }
  .fade-enter .user_input {
    opacity: 0;
    transform: translateX(-100%);
  }
  .fade-enter-active .user_input {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-exit .user_input {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-exit-active .user_input {
    opacity: 0;
    transform: translateX(100%);
  }
  .fade-enter-active .user_input,
  .fade-exit-active .user_input {
    transition: opacity 500ms, transform 500ms;
  }
  .varUploadBtn.ant-btn-primary {
    color: #fff;
    background-color: #000;
    border-color: #0000;
    border-radius: 20px;
    width: 175px;
    text-transform: uppercase;
    font-size: 12px;
  }
  .limitExceededAlert {
    text-transform: none;
  }
  .ant-result {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: ${props => props.messageStatus && '0 !important'};
  }
  .ant-result-title {
    font-size: 16px;
    font-weight: 700;
    .userDetailsSection {
      height: ${props => (props.currentStep ? '348px' : props.isEditable ? '200px' : '292px')};
      padding-bottom: ${props => (props.isEditable ? '0' : props.currentStep ? '' : '50px')};
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
  }
  .verifyDetail {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    margin: 18px;
    color: #000;
  }
  .editing {
    height: 100%;
    flex-direction: row;
    justify-content: space-around;
  }
  .divider {
    border: 0.5px solid #e5e5e5;
    margin-bottom: 30px;
  }
  .ant-table-thead > tr > th {
    font-weight: 700;
  }
  .ant-table-title{
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }
`;

export const ModalTagContainer = styled.div`
  display: flex;
  align-items: center;
  border: ${props => (props.border ? '1px solid #000' : '1px solid #b9b9b9')};
  border-radius: 8px;
  padding: 10px 10px 0px 10px;
  flex-wrap: wrap;
  max-height: ${props => props.tagSearch && '150px'};
  overflow: ${props => props.tagSearch && 'hidden'};
  overflow-y: ${props => props.tagSearch && 'auto'};
  background: ${props => props.tagSearch && '#fff'};
  @media only screen and (max-width: 1440px) {
    max-height: ${props => props.tagSearch && '100px'};
  }
  .ant-tag {
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    padding: 4px 7px;
    margin: 0px 10px 10px 0px;
    background: ${props =>
    props.tagSearch && 'linear-gradient(to right,#6B8DD6,#8E37D7) !important'};
    max-width: 100%;
    span {
      max-width: 96%;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .ant-tag .anticon-close {
    font-size: 14px !important;
    font-weight: 600 !important;
    color: ${props => (props.tagSearch ? '#000 !important' : '#df4c35 !important')};
    background: #fff !important;
    padding: 2px !important;
    border-radius: 25px !important;
    margin-left: 10px !important;
  }
  .ant-input {
    border: none !important;
    outline: none !important;
    margin-bottom: 10px !important;
    color: #171717 !important;
    ::placeholder {
      color: #767676 !important;
    }
    &.ant-input:focus {
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
    }
  }
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export const InputLabel = styled.div`
  font-weight: ${props => props.normal ? '' : '600'} ;
  font-size: ${props => (props.efax ? '15px' : props.ornanizationlist ? '18px' : '14px')};
  margin-bottom: ${props =>
    props.efax ? '5px' : !props.permission && '10px' ? props.signUp : '0px'};
  text-align: ${props => (props.userRole ? 'center' : props.signUp && 'left')};
  width: ${props => props.efax && '100%'};
  margin-top: ${props => props.efax && !props.signUp && '20px'};
  color: ${props => props.efax ? 'rgb(49 70 89 / 0.9)' : props.error && "#ba3939"};
  display: ${props => props.efax && 'flex'};
  align-items: ${props => props.efax && 'center'};
  text-transform: ${props => props.efax && 'uppercase'}; 
  .required:after {
    content:" *";
    color: red;
    margin-right: 4px;
  }
  .anticon {
    width: ${props => props.efax && '30px'};
  }
`;

export const InputContainer = styled.div`
  position: relative;
  margin-bottom: ${props => props.textArea ? '5px !important' : (!props.bottom ? '10px' : '0')}; 
  margin-left: ${props => !props.password && '10px'};
  margin-right: ${props => !props.password && '10px'};
  width: ${props =>
    props.user &&
    (props.isEditing ? '380px' : props.addUser ? '450px' : props.isMaster ? '425px' : '100%')};
  display: ${props => props.efax && 'flex'};
  flex-direction: ${props => props.efax && 'column'};
  text-align: ${props => props.permission && 'center'};
  margin: ${props => (props.permission || props.isMaster) && '15px !important'};
  margin-top: ${props => props.permission && '0px !important'};
  margin-top: ${props => props.textArea && '5px !important'};
  margin-top: ${props => props.signUp && '15px !important'};
  opacity: ${props => props.permission && props.disabled && '0.4'}; 
  cursor: ${props => props.permission && props.disabled && 'not-allowed'};
  margin-left: ${props => props.contactNum && '1.7%'};
  margin: ${props => props.isEditing && '10px'};
  @media (max-width: 768px) {
    width: auto;
    min-width: 250px;
  }

  .ant-select {
    width: 100% !important;
  }
  .ant-select-selection.ant-select-selection--multiple {
    margin-bottom: 12px;
  }
  .ant-select-selection {
    margin-bottom: 12px;
    height: 40px;
    .ant-select-selection__rendered {
      height: 100%;
      display: flex;
      align-items: center;
      .ant-select-selection__choice {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
      }
    }
    .ant-select-selection-selected-value {
      font-size: 16px;
      font-weight: 600;
    }
  }
  .select-user-roles ul {
    height: 40px;
  }
  &.flex-container {
    display: flex;
    align-items: center;
  }
  &:last-child {
    margin: ${props => !props.user && !props.signUp && '0px'};
    width: ${props => (props.tagInput ? '60%' : '')};
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    padding-right: ${props => props.efax && '12px'};
  }
  .ant-btn,
  .ant-btn[disabled] {
    color: #fff !important;
    background: #000 !important;
    border-color: #000;
    width: 45%;
    height: 40px;
    border-radius: 20px;
    text-transform: uppercase;
    font-size: 12px;
    margin: 10px;
  }
  .form_btn {
    text-align: center;
    margin: 20px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .ant-radio-checked .ant-radio-inner {
    border-color: #000;
  }
  .ant-radio-inner::after {
    background-color: #000;
  }
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus + .ant-radio-inner {
    border-color: #000;
    box-shadow: none !important;
  }
  .ant-radio-group {
    height: 60px;
    margin: 6px;
    margin-left: 0;
  }
  .userDetail {
    font-size: 14px;
    color: rgb(151 151 151);
    margin-left: 30px;
  } 
  .inputBox{
    height:45px;
  }
  .manageTag-input{
    height:40px;
    margin-bottom:5px
  }
 .email-manageTag-input{
    height:35px !important;    
    margin-bottom:10px
  }  
  .ant-input{
    :hover{
      border: 1px solid #c6c6c6 !important;
    }
   
  }
`;

export const AddNewCategory = styled.div`
  position: absolute;
  top: -7px;
  right: -10px;
  font-size: 12px;
  padding: 12px;
  color: #df4c35;
  font-weight: 600;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
`;

export const PopupContainer = styled.div`
  min-width: 240px;
  max-width: 250px;
  padding: 15px;
  position: relative;
  .ant-input {
    margin-bottom: 12px;
    color: #555555;
    font-size: 14px;
    font-weight: 600;
  }
  .ant-input:placeholder-shown {
    font-size: 12px;
    font-weight: normal;
  }
`;

export const PopupActionContainer = styled.div`
  display: flex;
  margin-top: 10px;
`;

export const PopupLabel = styled.div`
  color: rgb(49 70 89 / 0.9);
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 5px;
`;

export const SaveButton = styled(Button)`
  font-size: 12px;
  height: 30px;
  padding: 8px 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  background: #000;
  border-radius: 20px;
  color: #ffffff;
  border: 2px solid transparent;
  &:hover,
  &:focus {
    background: #000;
    color: #ffffff;
    border-color: transparent;
    box-shadow: initial;
  }
`;

export const CancelButton = styled(Button)`
  font-size: 12px;
  height: 30px;
  padding: 8px 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  background: #000;
  border-radius: 20px;
  color: #fff;
  border: 1px solid #000;
  margin-right: 10px;
  &:hover,
  &:focus {
    background: #000;
    color: #fff;
    border: 1px solid #000;
    box-shadow: initial;
  }
`;

export const UploadContainer = styled.div`
  height: 267px;
  .ant-form-explain {
    margin-bottom: 10px;
  }

  &.flex {
    height: auto !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const ThumbnailSlider = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 24px;
  margin-top: 18px;
  height: 725px;
`;

export const CarouselThumbnailDiv = styled.div`
  position: relative;
  box-shadow: 0px 0px 8px 3px rgb(103 110 144 / 20%);
  width: ${props => (props.isMailTemplates ? '90%' : '65.4%')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 35px;
  .ant-carousel {
    width: 100%;
    height: 100%;
    .slick-slide {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .preview_img {
    img {
      max-height: 700px;
      object-fit: ${props => props.isMailTemplates && 'contain'};
    }
  }
`;

export const SliderNavDiv = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transition: opacity 300ms ease;
  opacity: 0.3;
  z-index: 1;
`;

export const SliderNavButton = styled(Button)`
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0px 1px 3px rgb(103 110 144 / 20%);
  position: absolute !important;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  color: #000 !important;
  left: ${props => (props.previousbutton ? '-42px' : '')};
  right: ${props => (props.nextbutton ? '-42px' : '')};
`;

export const SliderThumbsdiv = styled.div`
  overflow-y: auto;
  padding-left: 6px;
  padding-right: 45px;
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #95989a;
  }
  .thumbsdiv-child {
    width: 125px;
    height: 170px;
    position: relative;
    display: flex;
    margin: 10px 0px 20px 15px;
    box-shadow: rgb(4 54 108 / 12%) 0px 0px 0px 2px;
    cursor: pointer;
  }
  .active {
    border: 2px solid rgb(0 0 0 / 95%);
    box-shadow: rgb(4 54 108 / 0%) 0px 0px 0px 2px !important;
  }
`;

export const PreviewTemplateDetails = styled.div`
  width: 100%;
  text-align: center;
  h2 {
    font-weight: 600;
    color: rgb(43, 42, 53);
    font-size: 22px;
    font-family: 'Open Sans', sans-serif;
  }
  p {
    color: rgb(147, 157, 168);
    font-size: 13px;
    width: 100%;
    line-height: 2.5;
  }
  .tags-div {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding-bottom: 20px;
    .edit-tag {
      font-size: 13px !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const SpaceBetweenFlex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const PageCountIndicator = styled.div`
  margin-left: 35px;
  font-size: 16px;
  font-weight: 500;
  color: #848484;
`;

export const ThumbPageCounter = styled.div`
  position: absolute;
  bottom: 8px;
  left: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  .page-counter {
    background-color: rgba(14, 19, 24, 0.7);
    color: #fff;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.6px;
    white-space: nowrap;
    padding: 0px 7px;
    border-radius: 6px;
  }
`;

/**
 * Bulk upload Modal styles
 */

export const BulkUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 25px;
  padding: ${props => props.imageUpload && '0 !important'};
  width: ${props => props.imageUpload && props.width};
  height: ${props => props.imageUpload && props.height};
  max-height: ${props => props.imageUpload && '85%'};
  background: ${props => !props.isImageGen && props.imageUpload && '#e7e7e7'};
  margin: auto;
  .anticon svg {
    font-size: ${props => (props.generatingImages ? '60px' : props.isImageGen && '30px')};
    color: ${props => !props.generatingImages && props.isImageGen && '#fff'};
  }
`;

export const BulkuploadErrorAlert = styled.div`
  width: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
  .ant-alert-error {
    width: 50%;
  }
`;

export const UploadButtonWrapper = styled.div`
  margin: 10px 0px;
  width: 96%;
  .ant-upload.ant-upload-select {
    width: 100%;
  }
`;

export const BulkUploadButton = styled.div`
  border: 1px dotted #949494;
  border-radius: 5px;
  padding: ${props => (props.initialUpload ? '65px' : '30px')};
  p {
    font-size: 22px;
    font-weight: 600;
    text-align: center;
  }
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    .anticon {
      font-size: 45px;
      color: #000000;
    }
  }
`;

export const UploadListWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  max-height: ${props => (props.imageUpload ? '100%' : '300px')};
  align-items: center;
  justify-content: center;
  // overflow-y: auto;
  margin: ${props => !props.imageUpload && '20px 0px'};
  padding: ${props => !props.imageUpload && '0px 5px'};
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #95989a;
  }
  > img {
    flex: 1;
    max-width: 47%;
    margin-right: ${props => !props.imageUpload && '10px'};
    max-height: 100%;
    max-width: 100%;
  }
  .uploadImage {
    opacity: 0;
    position: absolute;
  }
  &:hover {
    > img {
      opacity: 0.5;
    }
    .uploadImage {
      opacity: 1;
    }
  }
`;

export const UploadImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-basis: 124px;
  min-height: 120px;
  flex-grow: 1;
  max-width: 135px;
  width: 135px;
  border: ${props => (props.errorFile ? '1px solid red' : '1px solid #d9d9d9')};
  border-radius: 4px;
  padding: 10px;
  transition: transform 0.2s cubic-bezier(0.33, 0.04, 0.63, 0.93) 0s;
  &:hover {
    cursor: pointer;
    background: #dfdfdf85;
    .editor-area {
      display: block;
    }
    .overlay {
      display: block;
    }
  }
  .anticon-loading {
    font-size: 35px;
    color: #e05740;
  }
  .editor-area {
    position: absolute;
    top: 45%;
    left: 45%;
    display: none;
    z-index: 10;
    .anticon {
      font-size: 18px;
      padding-right: 10px;
      color: #d9d9d9;
    }
  }
  .overlay {
    position: absolute;
    display: none;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 2;
    cursor: pointer;
  }
`;

export const UploadActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
`;

export const UploadInputContainer = styled.div`
  max-width: 135px;
  width: 135px;
  margin-top: 5px;
  input {
    font-size: 12px;
    font-weight: 600;
    color: ${props => (props.errorFile ? 'red' : 'rgba(15, 13, 13, 0.98)')};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 8px;
    border: none;
    outline: none;
  }
`;

export const ColorLegend = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;

  &::before {
    content: '';
    width: 10px;
    height: 10px;
    margin-right: 10px;
    background: red;
    border-radius: 50%;
  }
`;

export const FontUploadCards = styled.div`
  display: flex;
  flex: initial;
  flex-direction: column;
  padding: 10px;
  border-radius: 6px;
  border: ${props => (props.errorFile ? '1px solid red' : '1px solid rgb(239, 241, 244)')};
  color: ${props => (props.errorFile ? 'red' : 'unset')};
  flex-basis: 31%;
  margin: 15px 15px 15px 0px;
  .card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    div {
      display: flex;
      align-items: center;
    }
    .card-text {
      display: block !important;
      margin-left: 15px !important;
      p {
        font-size: 14px !important;
        font-weight: 600;
      }
    }
    input {
      font-size: 12px;
      font-weight: 600;
      margin-left: 12px;
      width: 200px;
      background-color: rgb(248, 249, 251);
      color: ${props => (props.errorFile ? 'red' : 'rgba(15, 13, 13, 0.98)')};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 8px;
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
    }
    .anticon-loading {
      color: #e05740;
      font-size: 20px;
    }
    .anticon-font-size {
      font-size: 30px !important;
    }
    .anticon-delete {
      color: #000;
      font-size: 15px !important;
    }
    .icon {
      color: ${props => (props.errorFile ? 'red' : 'unset')};
    }
  }
`;

export const WarningLabel = styled.div`
  color: #f5222d;
  text-transform: initial !important;
  font-size: ${props => props.editUser && '14px !important'};
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: ${props => props.permission && 'center'};
  font-size: ${props => props.allIssue && '14px'};
  margin-top: ${props => props.allIssue && '5px'};
`;

export const LoaderContainer = styled.div`
  margin-bottom: 30px;
  height: ${props => props.isPrinterTag && '400px'};
`;

export const StepsAction = styled.div`
  margin-bottom: -25px !important;
  display: flex;
  justify-content: ${props =>
    props.isEditable ? 'center' : props.nextBtn ? 'flex-end' : 'space-between'};
  .ant-btn.ant-btn-primary {
    width: 20% !important;
    @media (max-width: 768px) {
      width: fit-content !important;
    }
  }
`;

export const RightAlign = styled.div`
  display: flex;
  justify-content: flex-end;
  a {
    color: #000;
    font-weight: 600;
  }
`;
export const InputRow = styled.div`
  display: flex;
  flex-direction: ${props => (props.addUser ? 'column' : 'row')};
  align-items: center;
  justify-content: ${props => (props.efax ? 'center' : 'space-around')};
  width: ${props => props.efax && '100%'};
  margin-left: ${props => props.efax && '20px'};
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
  .userName {
    width: 150px;
    border: transparent;
    border-bottom: 1px solid #d9d9d9;
    border-radius: 0;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: -10px;
    padding-bottom: 0px;
  }
  .ant-input {
    font-size: 15px;
    font-weight: 600;
  }
  .ant-input:hover,
  .ant-input:focus {
    border-color: #b9b8b8 !important;
    border-right-width: 1px !important;
    box-shadow: none !important;
  }
`;

export const TemplatesList = styled.div`
  font-size: 15px;
  max-height: 450px;
  width: ${props => props.isPrinterTag && '100%'};
  height: ${props => props.isPrinterTag && '450px'};
  overflow: auto;
  display: flex;
  justify-content: ${props => props.isLoading && 'center'};
  flex-direction: ${props => !props.isLoading && 'column'};
  border: ${props => !props.isLoading && '1px solid #cfcdcd'};
  align-items: center;
  p {
    margin: auto;
    padding: 8px;
  }
  .ant-btn-primary {
    align-self: ${props => props.isPrinterTag && 'end'};
    top: ${props => props.isPrinterTag && '10px'};
    right: ${props => props.isPrinterTag && '10%'};
    color: ${props => props.isPrinterTag && '#fff'};
    background-color: ${props => props.isPrinterTag && '#000'};
    border-color: ${props => props.isPrinterTag && '#000'};
    border-radius: ${props => props.isPrinterTag && '15px'};
    text-transform: ${props => props.isPrinterTag && 'capitalize'};
  }
  .ant-empty-normal {
    margin: ${props => props.isPrinterTag && '0 !important'};
    margin-top: ${props => props.isPrinterTag && '15% !important'};
    height: ${props => props.isPrinterTag && '150px !important'};
  }
  .ant-table-tbody > tr > td {
    a {
      color: #000;
      font-weight: 600;
    }
    a[disabled] {
      color: rgba(0, 0, 0, 0.25);
    }
  }
  .ant-table-wrapper {
    width: ${props => props.isPrinterTag && '100%'};
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    height: ${props => props.isPrinterTag && '65px'};
  }
  i.anticon.anticon-loading {
    font-size: 55px;
    color: #d54141;
  }
  .template {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 400px;
    padding: 15px;
    border-bottom: 1px solid #cfcdcd;
  }
  .ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
    ::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  }
  .ant-table-pagination.ant-pagination {
    text-align: center;
    float: none;
  }
  .ant-table-thead > tr > th {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
  }
  ////////////   table-pagination /////////
  .ant-table-pagination.ant-pagination {
    float: none;
    margin: 16px 0;
    text-align: center;
  }
  .ant-pagination-item a {
    text-decoration: none;
    transition: none;
  }
  .ant-pagination-item:focus a,
  .ant-pagination-item:hover a {
    color: #000;
  }
  .ant-pagination-item:focus,
  .ant-pagination-item:hover {
    border-color: #000;
  }
  .ant-pagination-item-active,
  .ant-pagination-item-active:hover,
  .ant-pagination-item-active:focus {
    font-weight: 500;
    background: #000;
    border-color: #000;
  }
  .ant-pagination-item-active a,
  .ant-pagination-item-active:focus a,
  .ant-pagination-item-active:hover a {
    color: #fff;
  }
  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    color: #000;
    border-color: #000;
  }
  .ant-pagination-disabled a,
  .ant-pagination-disabled:hover a,
  .ant-pagination-disabled:focus a,
  .ant-pagination-disabled,
  .ant-pagination-disabled:hover,
  .ant-pagination-disabled:focus {
    color: rgba(0, 0, 0, 0.25) !important;
    border-color: #d9d9d9 !important;
    cursor: not-allowed;
  }
  .ant-spin-nested-loading > div > .ant-spin {
    height: 450px;
    max-height: 450px;
  }
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
  .ant-modal-body {
    padding: 12px 24px 24px 24px !important;
  }
  .ant-modal-header {
    padding: 24px 12px 12px 12px !important;
  }
  .cAHRAq p {
    padding: 12px;
    word-break: break-word;
  }
  .ant-modal-close-x {
    font-size: 18px !important;
  }
  .ant-modal-close-x {
    width: 34px;
    height: 34px;
    line-height: 46px;
  }
  .cAHRAq {
    max-height: 500px;
    width: auto;
  }
`;

export const VariableList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 400px;
  .varScrollSec {
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    ::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  }

  p {
    font-size: 16px;
    line-height: 1.5;
  }
  .details {
    display: flex;
    flex-direction: row;
    border-bottom: 2px solid #d3d3d3;
    padding: 10px;
    padding-left: 0;
    width: 100%;
    justify-content: space-between;
  }
  .title {
    p {
      font-weight: 600 !important;
      text-transform: uppercase;
      font-size: 14px !important;
      color: #000;
    }
  }
  .name {
    font-size: 14px;
    width: 45%;
    text-align: left;
  }
  .type {
    font-size: 14px;
    width: 40%;
  }
  .maxLength {
    font-size: 14px;
    width: 20%;
  }
  .note {
    font-size: 14px;
    text-transform: initial;
    font-weight: 400;
    color: #979696;
    width: 100%;
    text-align: center;
    padding-top: 25px;
    padding-bottom: 35px;
  }
  .NoVariable {
    font-size: 16px;
    text-transform: initial;
    font-weight: 600;
    padding-bottom: 25px;
    height: 125px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .ant-btn,
    .ant-btn:active,
    .ant-btn:hover,
    .ant-btn:focus {
      outline: 0;
      width: 30%;
      border: 2px solid #000;
      background: #000;
      color: #fff;
      border-radius: 20px;
    }
  }
`;

export const RequestStatus = styled.div`
  display: flex;
  color: #000;
  font-size: 14px !important;
  padding: 20px;
  padding-left: 0;
  border-bottom: 2px solid #d3d3d3;
  justify-content: space-between;
  .reqID,
  .status {
    font-size: 14px !important;
    width: 55%;
    text-align: left;
  }
  .status {
    color: ${props =>
    props.eachReqStatus === 'failure'
      ? '#d90a0a'
      : props.eachReqStatus === 'success'
        ? '#1c9f1c'
        : props.eachReqStatus === 'processing'
          ? '#e39300'
          : '#000'};
    width: 45%;
  }
  .title {
    font-size: 14px !important;
    text-transform: uppercase;
    color: #000;
    font-weight: 700;
  }
`;

export const UpdateNote = styled.div`
  color: #ababab;
  letter-spacing: 0.5px;
  width: 250px;
  font-size: 11px;
  line-height: 1.5;
`;

export const PreviewPopUpSm = styled.div`
  display: flex;
  justify-content: center;
  .emptyMessage {
    margin: 8px;
    font-weight: 700;
    text-transform: uppercase;
  }
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 25%;
  height: 100%;
`;

export const InputSection = styled.div`
  display: flex;
  flex-direction: ${props => (props.isSearch ? 'row' : 'column')};
  align-items: ${props => (props.isSearch ? 'center' : 'flex-start')};
  justify-content: ${props => (props.isSearch ? 'space-around' : 'center')};
  padding-top: ${props => props.isSearch && '25px'};
  width: ${props => (props.isSearch ? '100%' : props.genButton ? '80%' : '60%')};
  height: ${props => props.genButton && '8%'};

  .ant-slider {
    width: 165px;
  }
  .ant-slider-dot {
    position: absolute;
    top: 0px;
    width: 0px;
    height: 4px;
    background-color: #fff;
    border: 1px solid #fff;
  }
  .ant-slider-rail {
    background-color: #dddddd;
  }
  .ant-input-affix-wrapper .ant-input {
    font-size: 13px !important;
  }
  .ant-input-affix-wrapper {
    width: 100% !important;
  }
  .ant-btn-primary {
    color: #fff;
    background-color: #000;
    border-color: #000;
    border-radius: 20px;
    text-transform: uppercase;
    font-size: 12px;
    display: flex;
    align-items: center;
    height: 30px;
    justify-content: center;
  }
  .ant-btn-primary:hover,
  .ant-btn-primary:focus {
    color: #fff;
    background-color: #000;
    border-color: #000;
    border-radius: 20px;
  }
  .ant-btn[disabled] {
    color: #fff !important;
    background-color: #000 !important;
    cursor: not-allowed !important;
  }
`;

export const FilterTitle = styled.div`
  color: #000;
  font-size: 11px;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  margin: 15px;
  margin-left: 0;
  margin-top: 30px;
  letter-spacing: 1px;
  text-align: left;
  width: 100%;
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

export const ImageSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 75%;
  height: 100%;
`;

export const PasswordContainer = styled.div`
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  flex-direction: column;

  .sucess_message{
    margin-top:20px;
    text-align:center;
    font-size:20px;
    font-family: "Glacial Indifference";
  }

  .lockContainer {
    border: ${props => (props.isValidPassword ? '1px solid #9defdc' : '1px solid #f7acaa')};
    padding: 22px;
    border-radius: 50%;
  }
  .btn-lock {
    display: inline-block;
    background: ${props => (props.isValidPassword ? '#9defdc' : '#f7acaa')};
    width: 64px;
    height: 64px;
    box-sizing: border-box;
    padding: 12px 0 0 18px;
    border-radius: 50%;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .btn-lock svg {
    fill: none;
    transform: translate3d(0, 0, 0);
  }

  .btn-lock svg .bling {
    stroke: #20cca5;
    stroke-width: 2.5;
    stroke-linecap: round;
    stroke-dasharray: 3;
    stroke-dashoffset: 15;
    transition: all 0.3s ease;
  }

  .btn-lock svg .lock {
    stroke: ${props => (props.isValidPassword ? '#71dac2' : '#ff5b5b')};
    stroke-width: 4;
    stroke-linejoin: round;
    stroke-linecap: round;
    stroke-dasharray: 36;
    transition: all 0.4s ease;
  }

  .btn-lock svg .lockb {
    fill: ${props => (props.isValidPassword ? '#71dac2' : '#ff5b5b')};
    fill-rule: evenodd;
    clip-rule: evenodd;
    transform: rotate(8deg);
    transform-origin: 14px 20px;
    transition: all 0.2s ease;
  }

  #inpLock {
    display: none;
  }

  label {
    background: ${props => (props.isValidPassword ? '#9defdc' : '#f7acaa')};
  }

  #inpLock:checked + label svg {
    opacity: 1;
  }

  .bling {
    animation: ${props => props.isValidPassword && 'bling6132 0.3s linear forwards'};
    animation-delay: ${props => props.isValidPassword && '0.2s'};
  }

  #inpLock:checked + label svg .lock {
    stroke-dasharray: ${props => !props.isValidPassword && '48'};
    animation: ${props => !props.isValidPassword && 'locked 0.3s linear forwards'};
  }

  #inpLock:checked + label svg .lockb {
    transform: rotate(0);
    transform-origin: 14px 22px;
  }

  @keyframes bling6132 {
    50% {
      stroke-dasharray: 3;
      stroke-dashoffset: 12;
    }

    100% {
      stroke-dasharray: 3;
      stroke-dashoffset: 9;
    }
  }

  @keyframes locked {
    50% {
      transform: translateY(1px);
    }
  }
  .ant-input-affix-wrapper {
    margin-top: 35px;
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    background: #f6fafd;
  }
`;

export const PasswordLabel = styled.div`
  font-weight: ${props => (props.desc ? '400' : '600')};
  font-size: ${props => (props.desc ? '14px' : '18px')};
  margin-bottom: 10px;
  color: ${props => (props.desc ? '#a09e9e' : '#000')};
  letter-spacing: 0.25px;
  text-align: center;
  margin: 20px;
  font-family: Montserrat !important;
`;


export const UpgradePlan = styled(Modal)`
  p {
    font-family: 'Open Sans', sans-serif;
    color: #000;
  }
  a {
    text-underline-position: under;
  }
  .footer {
    display: flex;
    column-gap: 24px;
    width: fit-content;
    margin: auto;
    flex-wrap: wrap;
  }
  .cancel-button {
    background: #f3f3f3;
  }
  .ant-modal-footer {
    padding-bottom: 34px !important;
  }
`;

export const EfaxModal = styled(Modal)`
.ant-modal-body {
  padding: 0 48px;
}
.ant-form-item:last-child {
  margin-bottom: 0;
}
.ant-modal-footer {
  padding: 30px 34px !important;
}
.ant-form-item label {
  font-size: 15px;
  font-weight: 600;
  .label-colon {
    margin-left: 2px;
  }
  .label-help-icon {
    margin-left: 5px;
  }
}
.ant-form-explain {
  margin-top: 4px;
}
`
export const ConfirmationPageModal = styled(Modal)`
  width: ${props => props.width}px !important; 
  .design_form {
    overflow: hidden;
    height: 420px;
  }
  .ant-modal-content {
    animation: ${props => !props.categ && slideInDown} 2s ease-in-out !important;
    background-color: ${props => props.ConfirmationPageDialog && "#000000"} !important;
    box-shadow: none !important;
    border-radius: 30px !important;
  }
  .ant-modal-header {
    padding: ${props => (props.messageStudio ? '26px 34px !important' : '')};
    background-color: ${props => props.ConfirmationPageDialog && "#000000"} !important;
    display:flex;
    justify-content:center; 
    border-radius: 30px 30px 0 0 !important;  
  }

  .ant-modal-title {
    font-size: 18px !important;
    font-family: 'Open Sans', sans-serif;
    font-weight: bold;
    text-transform: uppercase;
    color:#9cf7fa !important;
    width:340px
  }
  .ant-modal-body {
    overflow: hidden;
    display: ${props => (props.messageStudio ? 'flex' : '')};
    padding: ${props => (props.modalBodyPadding? props.modalBodyPadding : '34px 34px 50px 34px !important')};
    justify-content: ${props => (props.messageStudio ? 'center' : '')};
  }

  .ant-modal-close {
    top: 5px !important;
    right: 5px !important;
  }
  p {
    font-size: 15px;
    font-weight: bold;
    text-transform: uppercase;
    white-space: normal;
    text-align: center;
  }

  .fade-enter .design_input {
    opacity: 0;
    transform: translateX(-100%);
  }
  .fade-enter-active .design_input {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-exit .design_input {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-exit-active .design_input {
    opacity: 0;
    transform: translateX(100%);
  }
  .fade-enter-active .design_input,
  .fade-exit-active .design_input {
    transition: opacity 500ms, transform 500ms;
  }

  .content-wrapper{
    display:flex;
    align-items: center;
    gap: 38px; 
    .txt{
      font-size: 20px;
      width:70%
      color:#ffffff;
    }
  }
  .custom-btn{  
    width:30%;
  }
  .ant-modal-close-x{
    color:#ffffff;
  }
`;


export const HoverAnimationBtn = styled.div`
  button:hover {
    cursor: pointer;
  }
  button {
    position: relative;
    overflow: hidden;
    font-size: 11.4px;
    font-weight: 700 !important;
    letter-spacing: 1px;
    font-family: ${palette.FONT_FAMILY_LANDPAGE} !important;
    line-height: 1.3;
    height: ${props => (props.height ? props.height : '40px')};
    width: 180px;
    text-transform: uppercase;
    border-radius: 64px;
    background-color: ${palette.APP_BRAND_YELLOW_COLOR};
    border: ${palette.APP_BRAND_YELLOW_COLOR};
    animation: ${fadeText} 1s ease-in-out 0s forwards;
    color: #000;
    z-index: 1;
    @media only screen and (min-width: 2560px) {
      font-size: 22px;
      height: 85px;
      letter-spacing: 1.5px;
      width: 380px;
    }
  }
  button:hover:before {
    opacity: 1;
    transform: translate(0, 0);
  }
  button:before {
    content: attr(data-hover);
    position: absolute;
    left: 0;
    width: 100%;
    text-transform: uppercase;
    opacity: 0;
    transform: translate(0, 100%);
    transition: all 0.2s ease-in-out;
  }
  button:hover div {
    opacity: 0;
    transform: translate(0, -100%);
  }
  button div {
    text-transform: uppercase;
    transition: all 0.2s ease-in-out;
  }
`;

export const DesignWrapper = styled.div` 
margin:auto;
`

export const Ornanizationlistcontainer = styled.div`
  width:90%;
   margin-top:30px;
    .ant-select-selection--single {
      height: 40px !important;
    }
   .ant-select-selection__rendered {
    line-height: 38px !important;
   }
`
export const AutoCloseModalStyles = styled(Modal)`
  .ant-modal-body {
    padding: 0;
    overflow: hidden;
  }
  @keyframes move {
    100% {
      transform: translateX(0%);
    }
  }
  .time-progress-bar {
    height: 6px;
    width: 100%;
    background: linear-gradient(90deg,rgba(131, 58, 180, 1) 0%, rgba(253, 29, 29, 1) 50%, rgba(252, 176, 69, 1) 100%);
    transform: translateX(-100%);
    animation: move ${props => props.closeTimeoutSec}s linear;
  }
  .success {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 24px;
    gap: 24px;
    h4 {
      font-size: 18px;
      font-weight: 700;
      text-align: center;
    }
  }
  .ant-modal-footer {
    display: none;
  }
  .check-icon {
    @supports (animation: grow 0.5s cubic-bezier(0.25, 0.25, 0.25, 1) forwards) {
      .tick {
        stroke-opacity: 0;
        stroke-dasharray: 29px;
        stroke-dashoffset: 29px;
        animation: draw 0.5s cubic-bezier(0.25, 0.25, 0.25, 1) forwards;
        animation-delay: 0.6s;
      }
      .circle {
        fill-opacity: 0;
        stroke: url(#MyGradient);
        stroke-width: 16px;
        transform-origin: center;
        transform: scale(0);
        animation: grow 1s cubic-bezier(0.25, 0.25, 0.25, 1.25) forwards;
      }
    }
    @keyframes grow {
      60% {
        transform: scale(0.8);
        stroke-width: 4px;
        fill-opacity: 0;
      }
      100% {
        transform: scale(0.9);
        stroke-width: 8px;
        fill-opacity: 1;
        fill: url(#MyGradient);
      }
    }
    @keyframes draw {
      0%,
      100% {
        stroke-opacity: 1;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
  }
`;

export const TransacCompleteModal = styled(Modal)`
  font-family: 'Open Sans', sans-serif;
  .ant-modal-title {
    font-weight: 700;
    font-size: 20px;
  }
  .ant-modal-body {
    text-align: center;
  }
  h4 {
    padding-top: 8px;
  }
`;

export const StyledQuillEditorModal = styled(Modal)`
  .ant-modal-footer {
    padding-bottom: 24px !important;
  }
`;

export const SignUpPromptModal = styled(Modal)`
  .ant-modal-content {
    position: relative;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    
    &::before {
      content: '';
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      background: linear-gradient(90deg, #ffde59, #ff914d);
      border-radius: 10px;
      z-index: -1;
    }
  }
  
  .ant-modal-header {
    border-bottom: 1px solid #e8e8e8;
    background-color: #fafafa;
    border-radius: 6px 6px 0 0;
  }
  
  .signup-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    width: 100%;
    
    .signup-text {
      font-size: 16px;
      text-align: center;
      margin-bottom: 20px;
      
      p {
        margin: 0;
        line-height: 1.6;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        flex-wrap: wrap;
      }
      
      span {
        color: ${palette.BLACK_COLOR};
        font-family: ${palette.FONT_FAMILY_LANDPAGE};
        line-height: 1.5;
        display: inline;
        vertical-align: baseline;
      }
      
      a {
        color: ${palette.BLACK_COLOR};
        text-decoration: underline;
        font-weight: normal;
        
        &:hover {
          color: ${palette.APP_BRAND_YELLOW_COLOR};
        }
      }
    }
  }
  
  .ant-modal-title {
    font-weight: 700;
    font-size: 18px;
    text-align: center;
  }
  
  .ant-modal-footer {
    text-align: center;
    border-top: 1px solid #e8e8e8;
    background-color: #fafafa;
    border-radius: 0 0 6px 6px;
    
    .ant-btn {
      margin: 0 8px;
    }
  }
`;

export const SetupFailureModal = styled(Modal)`
  * {
    font-family: 'Lato', sans-serif;
  }
  .ant-modal-footer {
    padding: 0 24px 24px !important;
  }
  p {
    color: #000;
  }
`;

export const SignUpPromptStyles = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 40px;
  .card {
    border-radius: 12px;
    width: 400px;
    padding: 24px;
    text-align: center;
    background: linear-gradient(137.73deg, rgb(23, 2, 60) 3.35%, rgb(219, 57, 31) 97.84%);
    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 50px;
  }
  .card img {
    width: 100px;
    animation: move-up-down 2s linear infinite; 
  }
  @keyframes move-up-down {
    0% {
      transform: translateY(-15px);
    }
    50% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-15px);
    }
  }
  .card h2 {
    color: #fff;
    font-size: 20px;
    font-family: Glacial Indifference;
  }
  .ant-btn {
    height: 48px;
    border: none;
    border-radius: 12px;
    padding-inline: 24px;
    color: #fff;
    background: #000;
    font-size: 16px;
    font-weight: 600;
    font-family: Glacial Indifference !important;
    text-transform: uppercase;
    letter-spacing: 1px;
    display: flex;
    align-items: center;
  }
  .ant-btn:disabled, .ant-btn:hover, .ant-btn:active {
    background: #000 !important;
    color: #fff !important;
  }
  .ant-btn:disabled {
    opacity: 0.5;
  }
  .ant-btn:hover:not(:disabled) {
    transform: scale(1.02);
    transition: transform 0.2s linear;
  }
`;